import client from '../client';

export const trackingIdsApi={
  // 获取列表
  getTrackingIds: data => {
    return client.get('publisher/tracking-ids', {params:data}).then(res => res.data);
  },
  // 添加追踪ID
  addTrackingId: data => {
    return client.post('publisher/tracking-ids', data).then(res => res.data);
  },
  // 删除追踪ID
  deleteTrackingId: id => {
    return client.delete(`publisher/tracking-ids/${id}`).then(res => res.data);
  },
  // 获取子追踪ID
  getSubTrackingIds: primaryId => {
    return client.get(`publisher/tracking-ids/${primaryId}/sub-ids`).then(res => res.data);
  }

}
